/**
 * Money amounts in the new-look billing flow: whole amounts stay whole and
 * others always show cents ("$15.20", not "$15.2"). Accepts numbers or
 * strings such as "$374.4".
 */
export const formatMoney = (value?: number | string | null) => {
  if (value === undefined || value === null || value === "") return value;
  const number = Number(String(value).replace(/[$,\s]/g, ""));
  if (isNaN(number)) return value;
  return Number.isInteger(number) ? number.toString() : number.toFixed(2);
};
